<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <Logo></Logo>
    <Welcome></Welcome>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <div class="column is-half">
            <label
              :class="
                $root.selectedLanguage === `ta`
                  ? `tamilLabel`
                  : $root.selectedLanguage === `si`
                  ? `sinhalaLabel`
                  : ``
              "
            >
              {{ $root.selectedLanguageData.selectedIDType }}</label
            >
            <b-field>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-select
                  v-model="$root.formData.idType"
                  rounded
                  expanded
                  @change.native="resetProofNumber()"
                >
                  <option value="ONIC">
                    {{ $root.selectedLanguageData.nic_type1 }}
                  </option>
                  <option value="NNIC">
                    {{ $root.selectedLanguageData.nic_type2 }}
                  </option>
                  <option value="PNO">
                    {{ $root.selectedLanguageData.passport_no }}
                  </option>
                </b-select>
                <span class="has-text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-field>
          </div>
        </div>

        <div class="columns is-centered mb-0">
          <div
            class="column is-half has-text-centered is-flex is-flex-direction-row-reverse"
          >
            <b-button
              class="continue-button is-primary is-rounded"
              :disabled="invalid"
              @click="$router.push('nic')"
              >{{ $root.selectedLanguageData.continue }}</b-button
            >
            <b-button class="back-button is-rounded" @click="$router.go(-1)">{{
              $root.selectedLanguageData.back
            }}</b-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import Welcome from "./WelcomeForm.vue";
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
export default {
  components: {
    Welcome,
    GetHelp,
    Logo,
  },
  data() {
    return {};
  },

  methods: {
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step: 2,
          },{
             headers:{'X-token':kyc_token}
           })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
    resetProofNumber() {
      this.$root.formData.customer_passport_no = "";
      this.$root.formData.customer_nic = "";
    },
  },

  mounted: function () {
    this.updateLastStep();
  },
};
</script>
<style lang="scss" scoped></style>
